import { useState } from 'react';

interface NotesEditorProps {
  body: string;
  onSave: (body: string) => void | Promise<void>;
  saving?: boolean;
}

export function NotesEditor({ body, onSave, saving }: NotesEditorProps) {
  const [draft, setDraft] = useState(body);
  const dirty = draft !== body;

  const handleSave = async () => {
    await onSave(draft);
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-4">
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-base font-semibold text-gray-900">Notes</h2>
        {dirty && <span className="text-xs text-amber-600">Unsaved changes</span>}
      </div>
      <textarea
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        rows={8}
        className="w-full rounded-md border border-gray-300 p-3 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-900 resize-y"
        placeholder="Add notes about this video…"
      />
      <div className="flex justify-end mt-3">
        <button
          onClick={handleSave}
          disabled={saving || !dirty}
          className="text-sm px-4 py-2 rounded bg-gray-900 text-white hover:bg-gray-800 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {saving ? 'Saving…' : 'Save notes'}
        </button>
      </div>
    </div>
  );
}
